"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var FileTypeTxt = function FileTypeTxt(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    fill: "none"
  }, props), (0, _preact.h)("path", {
    fill: "#5c6970",
    fillRule: "evenodd",
    d: "M8 0C5.796875 0 4 1.796875 4 4v7H1c-.550781 0-1 .449219-1 1v6c0 .550781.449219 1 1 1h3v3c0 2.203125 1.796875 4 4 4h12c2.203125 0 4-1.796875 4-4V8c0-1.0625-.972656-2.070312-2.71875-3.78125-.242187-.238281-.503906-.503906-.75-.75-.246094-.246094-.511719-.476562-.75-.71875C18.070313 1.003906 17.0625 0 16 0H8zm0 2h7.28125c.722656.183594.71875 1.050781.71875 1.9375V7c0 .550781.449219 1 1 1h3c.996094 0 2 .003906 2 1v13c0 1.105469-.894531 2-2 2H8c-1.105469 0-2-.894531-2-2v-3h12c.550781 0 1-.449219 1-1v-6c0-.550781-.449219-1-1-1H6V4c0-1.105469.894531-2 2-2z"
  }), (0, _preact.h)("path", {
    fill: "#fff",
    d: "M6.79883 13.2617H5.05664V18H3.88477v-4.7383H2.16602v-.9492h4.63281v.9492zm2.70312 1.0117l1.06641-1.961h1.34766l-1.65625 2.8203L11.959 18h-1.36329l-1.09374-1.9922L8.40821 18H7.04493l1.69921-2.8672-1.65625-2.8203h1.34766l1.06641 1.961zm7.32815 0H15.0879V18h-1.17187v-4.7383h-1.71875v-.9492h4.63282v.9492z"
  }));
};

var _default = FileTypeTxt;
exports.default = _default;